export default __webpack_public_path__ + "static/company-masthead-bg-245202c2b04f5b286cb0af311c09d56e.png";